import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Impact2 from "./Impact2";
import Testimonials from "./Testimonials";
import reviews from "./data";


import syep2024 from "../../Assets/syepMain.png";

import syep2 from "../../Assets/syep_2025_2.jpg";
import syep2025 from "../../Assets/syep_2025.jpeg";
import gradSYEP2024 from "../../Assets/gradSYEP.png";
import gradSYEP2025 from "../../Assets/SYEP_2025_Grad.png";
import syep3 from "../../Assets/syep_2025_3.jpg";



// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
  { src: syep2, alt: "syep" },
  { src: syep3, alt: "syep" },
  { src: syep2024, alt: "syep" },
  { src: gradSYEP2024, alt: "syep" },  
  { src: syep2025, alt: "syep" }, 
   { src: gradSYEP2025, alt: "syep" }, 
  



  // Add more images as needed

  ];


function Impact() {

  const navigate = useNavigate(); // Initialize navigate
    
  
  const handleClick = () => {
    navigate("/registration#internship-section"); // This will navigate to the "/another-page" route
  };

  


  // Settings for the Slick slider
  const settings = {
    dots: false, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Time between slides in ms
  };


  return (
    <Container fluid className="about-section impact-page">
      <Particle />
      <Container className="impact-container">
        <header className="impact-hero">
          <h1 className="impact-hero-title">
            Our <strong className="purple">Impact</strong>
          </h1>
          <p className="impact-hero-lead">
            Real-world internships, community-centered learning, and partnerships that create measurable growth.
          </p>
          <div className="impact-hero-cta">
            <Button onClick={handleClick} className="custom-yellow-btn impact-apply-btn">
              Apply Now
            </Button>
          </div>
        </header>

        <Row className="impact-top" style={{ justifyContent: "center" }}>
          <Col md={7} className="impact-left">
            <div className="policy-card impact-slider-card" aria-label="Internship highlights">
              <Slider {...settings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="impact-slide">
                    <img src={image.src} alt={image.alt} className="impact-slide-img" />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>

          <Col md={5} className="impact-right">
            <div className="policy-card impact-summary-card">
              <h2 className="impact-card-title">Internship Program</h2>
              <p className="about-text impact-card-text">
                Our SYEP-aligned internships give learners real work experience in ethical, community-driven technology.
              </p>
              <ul className="impact-bullets">
                <li>Build practical skills through hands-on projects</li>
                <li>Collaborate with peers and mentors</li>
                <li>Grow leadership, confidence, and career readiness</li>
              </ul>

              <Button onClick={handleClick} className="custom-yellow-btn impact-apply-btn impact-apply-btn-secondary">
                Apply Here
              </Button>
            </div>
          </Col>
        </Row>

        <Impact2 onApply={handleClick} />

        <section className="impact-testimonials-section" aria-label="Testimonials">
          <h2 className="impact-section-heading">
            Testimonials
          </h2>
          <div className="impact-testimonials">
            <Testimonials reviews={reviews} />
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default Impact;
